import { render, staticRenderFns } from "./LogoutScreen.vue?vue&type=template&id=70b8ee56&scoped=true&"
import script from "./LogoutScreen.vue?vue&type=script&lang=js&"
export * from "./LogoutScreen.vue?vue&type=script&lang=js&"
import style0 from "./LogoutScreen.vue?vue&type=style&index=0&id=70b8ee56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8ee56",
  null
  
)

export default component.exports